



















































import Vue from 'vue'
import AddOrEditInterfaceSetting from './components/AddOrEditInterfaceSetting.vue'
import { InterfaceConfigServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CHART_TYPES, INTERFACE_METHODS } from './commonDef'
const interfaceConfigServiceProxy = new InterfaceConfigServiceProxy()
export default Vue.extend({
  name: '',
  components: {
    AddOrEditInterfaceSetting
  },
  data() {
    return {
      dataSource: [],
      selectedRowKeys: [],
      addFlag: false,
      selectedRow: {},
      visible: false
    }
  },
  created() {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: '操作',
          key: 'action',
          fix: 'left',
          width: 150,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '接口url',
          dataIndex: 'url',
          width: 200
        },
        {
          title: '接口中文名',
          dataIndex: 'urlName',
          width: 200
        },
        {
          title: '接口类型',
          dataIndex: 'urlType',
          width: 200,
          customRender: (text,record) => {
            const filter = INTERFACE_METHODS.find(res => res.value === text) || {}
            return filter['label']
          }
        },
        {
          title: '接口所属图表',
          dataIndex: 'owningChart',
          width: 200,
          customRender: (text,record) => {
            if (text) {
              const arr = text.split(',')
              const showName = []
              CHART_TYPES.forEach(res => {
                arr.forEach(re => {
                  if (res.value === re) {
                    showName.push(res.label)
                  }
                })
              })
             return showName.toString()
            }
          }
        },
      ]
    }
  },
  methods: {
    getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  },
    // 表格勾选
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      // console.log(selectedRowKeys)
    },
    handleEdit(record) {
      console.log('edit', record)
      this.visible = true
      this.addFlag = false
      this.selectedRow = record
    },
    handleDelete(flag, id) {
      const param = flag ? this.selectedRowKeys : [id]
      interfaceConfigServiceProxy.delete(param).then((res) => {
        this.$message.info('删除成功')
        this.getList()
      })
    },
    close(flag) {
      this.visible = false
      if (flag) {
        this.getList()
      }
    },
    getList() {
      interfaceConfigServiceProxy.getPage(1, 9999).then((res) => {
        // this.dataSource = res.data.records

        let dataLength = res.data.records.length;
        let copy = JSON.parse(JSON.stringify(res.data.records));
        let needPush = 0;
        if(dataLength < 30) {
          needPush = 30 - dataLength;
          for(var k=0; k<needPush; k++) {
            let obj = {  
              // id: 'none'
            }
            copy.push(obj)  
          }
        }
        this.dataSource = JSON.parse(JSON.stringify(copy));

      })
    }
  }
})
